import React from "react";
import { observer } from "mobx-react";
import { Link } from "react-router";
import { routes } from "modules/common/routes";
import { SimpleMessage, SimpleMessageProps } from "./SimpleMessage";
import { OrderTabs } from "modules/orders-manage/details/OrderDetailsTabsPage";
import { EMPTY_OBJECT_ID } from "modules/common/constants";

export const OrderRelativeMessage = observer(
    class extends React.Component<OrderRelativeMessageProps> {
        render() {
            const { message, ...rest } = this.props;
            const orderId = message.data.get("OrderId");
            const tab = message.data.get("OrderTab") || OrderTabs.summary;
            const unitGuid = message.data.get("UnitGuid") || null;
            const questionId = message.data.get("QuestionId") || "";
            // у заданий личных досок договора нет — ссылку на договор не показываем
            const hasOrder = !!orderId && orderId !== EMPTY_OBJECT_ID;
            let option = "";
            if (unitGuid) {
                option = "&rowId=" + unitGuid;
            }
            return (
                <SimpleMessage message={message} {...rest}>
                    {hasOrder && <Link to={routes.orders.details(orderId, tab) + option}>Перейти к договору</Link>}
                    {hasOrder && questionId && <>&nbsp;</>}
                    {questionId && (
                        <a
                            href={routes.orders.orderQuestionDetails(questionId)}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Открыть задание
                        </a>
                    )}
                </SimpleMessage>
            );
        }
    }
);

interface OrderRelativeMessageProps extends SimpleMessageProps {}
